(function () {
  class Customer extends Common {
    constructor() {
      super()
    };

    configure() {
      // BY ID
      this.ui.customerIdNumber = "#customer_id_number";
      this.ui.customerNationality = "#customer_nationality";
      this.ui.customerDetailsIdEq = '#q_id_eq';
      this.ui.customerBirthDate = '#customer_birth_date'
    };

    loadComponents() {
      this.configure();
      this.needFormValidation();
      this.changeNationality();
      this.loadCustomFileInput();
      this.loadValidateBirthDate();
      this.loadCustomerAgeDisplay();
    };

    changeNationality() {
      const operation = this;
      const $nit = $("#customer_nit");
      const isPanama = gon?.global?.integration_type?.country === "pan";

      function syncNitFromIdNumber() {
        if (!isPanama) return;
        const nationality = $(operation.ui.customerNationality).val();
        const idNumber = $(operation.ui.customerIdNumber).val();
        if (nationality === "national" || nationality === "naturalized") {
          if (idNumber) {
            $nit.val(idNumber).prop("readonly", true).addClass("bg-light");
          }
        } else {
          $nit.prop("readonly", false).removeClass("bg-light");
        }
      }

      $(operation.ui.customerNationality).on("change", function () {
        var selected = $(this).find("option:selected").val();

        if (selected == "national" || selected == "naturalized") {
          $(operation.ui.customerIdNumber).addClass("formatDNI");
          $(operation.ui.customerIdNumber).rules("add", { formatDNI: true });
        } else if (selected == "foreigner" && isPanama) {
          $(operation.ui.customerIdNumber).addClass("formatDNI");
          $(operation.ui.customerIdNumber).rules("add", { formatDNI: true });
        } else {
          $(operation.ui.customerIdNumber).removeClass("formatDNI");
          $(operation.ui.customerIdNumber).rules("remove", "formatDNI");
        }

        if ($(operation.ui.customerIdNumber).val() != "") {
          $(operation.ui.customerIdNumber).valid();
        }

        syncNitFromIdNumber();
      });

      $(operation.ui.customerIdNumber).on("input change blur", syncNitFromIdNumber);
      syncNitFromIdNumber();
      $(operation.ui.customerNationality).trigger("change");
    }

    changeCustomerDetails() {
      const operation = this;

      $(operation.ui.customerDetailsIdEq).on('change', function () {
        var selected = $(this).find('option:selected').val();

        bootbox.dialog({
          centerVertical: true,
          closeButton: false,
          message: i18n.t('bootbox.processing_html')
        });

        $.ajax({
          method: 'GET',
          url: Routes.customer_detail_path({ id: selected, format: "js" }),
          dataType: 'script'
        }).done(function () {
          operation.hideBootBox();
        }).fail(function () {
          operation.hideBootBox();
        }).always(function () {
          operation.hideBootBox();
        });
      });
    };
  };

  window.Customer = Customer;
})();
